import React from 'react'
import { Milestone } from '../Reusable/Choose'

const MilesStone = () => {
    return (
        <div data-aos="fade-right" className='flex bg-[#06000A] flex-col lg:gap-10 gap-5 lg:px-[8%] px-[4%] lg:pt-[6%] py-[6%]'>
            <div className='flex w-full items-center justify-center'>
                <div className='lg:w-[40%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[55px] text-[30px] text-white font-semibold '>Our Milestones</p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe."</p>
                </div>
            </div>

            <div className='flex lg:flex-row flex-col w-full justify-between gap-5 '>
                <Milestone
                    img={"/Blockfarm/miners.svg"}
                    heading={"5000+ Miners Sold"}
                    paragraph={"Our role as a leading provider in the mining equipment industry."}
                />
                <Milestone
                    img={"/Blockfarm/strike.svg"}
                    heading={"12 MW Megawatts"}
                    paragraph={"scalable solutions tailored to the needs of modern mining operations."}
                />
                <Milestone
                    img={"/Blockfarm/ph.svg"}
                    heading={"360 PH/s Hashrate"}
                    paragraph={"Dedicated to mining operations, ensuring optimal performance & reliability."}
                />
            </div>
        </div>
    )
}

export default MilesStone